const REMOTE_SERVER = 'https://dabbawalaapi.iosx.in:3091/';
export default REMOTE_SERVER;